<template>
  <v-app>
    <!-- <v-app-bar app color="blue" dark clipped-left>
      <v-spacer></v-spacer>
      <div>Quanticy</div>
      <v-spacer></v-spacer>
    </v-app-bar> -->

    <v-main>
      <router-view />
    </v-main>

    <v-bottom-sheet
      v-model="cookiesNote"
      class="pb-15"
      persistent
    >
      <v-sheet
        v-if="cookiesNote"
        class="text-center"
        tile
        outlined
        style="z-index: 1000"
        persistent
      >
        <div class="pt-3">
          Diese Website verwendet ausschließlich technisch notwendige Cookies.
          Weitere Informationen zu Cookies finden Sie in unserer
          <a
            href="https://www.spicetech.de/datenschutzerklaerung/"
            target="_blank"
          >Datenschutzerklärung</a>.
        </div>
        <v-btn
          class="my-10"
          text
          color="info"
          @click="acceptCookies"
        >
          Verstanden
        </v-btn>
        <Footer />
      </v-sheet>
    </v-bottom-sheet>
    <snackbar />
    <auto-logout-dialog v-model="autoLogoutDialog" />
  </v-app>
</template>

<script>
import Footer from "@/shared/Footer";
import Snackbar from './components/alerts/Snackbar.vue';
import AutoLogoutDialog from './components/dialogs/AutoLogoutDialog.vue';
import { mapGetters } from "vuex";
const cookie = require('cookie');

export default {
  name: "App",
  components: { 
    Footer,
    Snackbar,
    AutoLogoutDialog
  },
  data() {
    return {
      cookiesNote: true,
      sessionTimeout: null,
      autoLogoutDialog: false
    }
  },
  computed: {
    ...mapGetters(["user"]) 
  },
  created() {
    this.setSessionTimeout();
    if (cookie.parse(document.cookie).hideCookieBanner == 'true') {
      this.cookiesNote = false;
    }
  },
  mounted() {
    // reset session timeout timer after all api calls
    window.EventBus.$on("refreshSessionTimeout", () => this.setSessionTimeout());
  },
  methods: {
    // show auto logout dialog after 2 hours of inactivity
    setSessionTimeout: function() {
      if (!this.user.lastname) {
        return;
      }
      if (this.sessionTimeout) {
        clearTimeout(this.sessionTimeout);
      }
      this.sessionTimeout = setTimeout(() => {this.autoLogoutDialog = true}, 7200000);
    },
    acceptCookies: function() {
      this.cookiesNote = false;
      document.cookie = cookie.serialize("hideCookieBanner", "true", {sameSite: true})
      window.EventBus.$emit("resizeMap");
      window.EventBus.$emit("checkForShepherdTourStart");
    }
  }
};
</script>
